/* ImageEditRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const Cropper = require("croppie");
const _ = require("lodash");

class ImageEditRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElement();
        this._imageExists = !!this._model._existingImage;

        this._title = _.get(this._model._editorOpts, 'title', 'Edit Photo');
        this._description = _.get(this._model._editorOpts, 'description', 'Click-and-drag or zoom to optimize your photo');
        this._okBtnTxt = _.get(this._model._editorOpts, 'okText', 'Add');
        this._cancelBtnTxt = _.get(this._model._editorOpts, 'cancelText', 'Cancel');

        this._cropperConfigOpts = {
            viewportHeight: 200,
            viewportWidth: 200,
            boundaryWidth: 400,
            boundaryHeight: 400
        };

        this._cropperConfigOpts = _.assign({}, this._cropperConfigOpts, this._model._config);
        this._previewImageCont = document.createElement("image-preview");
        this._buttonsContainer = document.createElement("buttons-list");

        this._titleEl = document.createElement("h2");
        this._titleEl.innerHTML = this._title;

        this._descriptionEl = document.createElement("p");
        this._descriptionEl.innerHTML = this._description;

        this._cancelButton = new ButtonControl({
            id: "cancel",
            label: this._cancelBtnTxt,
            darkTheme: true
        });
        this._saveButton = new ButtonControl({
            id: "save",
            label: this._okBtnTxt,
            darkTheme: true,
            active: true
        });
        this._cropperContainer = document.createElement('div');
        this._cropperContainer.setAttribute("id", "crop");
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown(){
        const promArr = [
            this._cropper ? this._cropper.destroy() : "",
            this._saveButton.shutdown(),
            this._cancelButton.shutdown()
        ];
        return Promise.all(promArr).then(()=>{
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._imageExists = undefined;

            this._cropperConfigOpts = undefined;

            this._cropperConfigOpts = undefined;
            this._previewImageCont = undefined;
            this._buttonsContainer = undefined;

            // this._editButton = new ButtonControl({id: "edit", label: "Edit Image", disabled: true});
            this._saveButton = undefined;
            this._cancelButton = undefined;
            this._cropperContainer = undefined;
            this._title = undefined;
            this._description = undefined;
            this._okBtnTxt = undefined;
            this._cancelBtnTxt = undefined;
            //TODO set all class members to undefined here
            return Promise.resolve();
        });
    }
    _registerListeners(){
        this._saveButton.on("UserClick", (this._onSave = this._onSave.bind(this)));
        this._cancelButton.on("UserClick", this._onCancel = this._onCancel.bind(this));
    }
    _unregisterListeners(){
        this._saveButton.removeListener("UserClick", this._onSave);
        this._cancelButton.removeListener("UserClick", this._onCancel);
    }

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("image-edit-control", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    _onCancel() {
        this._model.closePopUp();
    }
    _onSave() {
        if(this._cropper) {
            return this._cropper.result({type: "base64", size: {width: 200, height: 200}})
                .then(data => {
                    this._model._context.resolve(data);
                });
        } else {
            this._model._context.resolve("");
        }
    }

    _setImagePreview(imageSrc) {
        if(imageSrc) {
            const img = document.createElement("img");
            img.src = imageSrc;
            this._previewImageCont.innerHTML = "";
            this._previewImageCont.appendChild(img);
        } else {
            this._previewImageCont.innerHTML = "Image not available";
        }
        return this._previewImageCont;
    }

    _renderButtons() {
        this._buttonsContainer.innerHTML = "";
        this._buttonsContainer.appendChild(this._cancelButton.renderer.rootElement);
        this._buttonsContainer.appendChild(this._saveButton.renderer.rootElement);
    }

    _renderPreview() {
        this._cropperContainer.innerHTML = "";
        this._cropper = new Cropper(this._cropperContainer, {
            mouseWheelZoom: false,
            boundary: { 
                width: this._cropperConfigOpts.boundaryWidth,
                height: this._cropperConfigOpts.boundaryHeight
            },
            viewport: {
                width: this._cropperConfigOpts.viewportWidth,
                height: this._cropperConfigOpts.viewportHeight,
                type: "circle"
            }
        });
        this._cropper.bind({url:this._model._existingImage});
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._titleEl);
        this._rootElem.appendChild(this._descriptionEl);
        this._rootElem.appendChild(this._previewImageCont);
        this._previewImageCont.appendChild(this._cropperContainer);        
        if(this._imageExists) {
            this._renderPreview();
        }
        this._rootElem.appendChild(this._buttonsContainer);
        this._renderButtons();
        // this._enableDisableButtons(this._imageExists);
        return Promise.resolve();
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown(){
        this._shutdown();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports=ImageEditRenderer;